// The receive screen keeps what the operator booked in local state (submitData) and rebuilds it
// from the loaded return or order whenever that data changes. The rebuild empties the booked
// list, so it may only run when the screen is opening a different return/order, or when nothing
// was booked yet.
//
// The ids come from two sources with different types: the route param is always a string
// ("1284841") and the API payload carries a number (1284841). Compared strictly they never match,
// so every refetch read as "a different return" and emptied the list. A refetch is routine here:
// react-query refetches on window focus, and the return payload carries live stock counts for the
// order's products, so the refetched object is almost always new. Emptied silently while the
// confirm dialog was open, the list then went out with every expected unit auto-flagged missing,
// and the platform closed the return as UNSUCCESSFUL with no receipt (BUGS-8974). Compare as
// strings.
export const isSameEntity = (a, b) => a !== undefined && a !== null && b !== undefined && b !== null && String(a) === String(b)

// currentId: the return/order the screen is showing now. heldId: the one submitData was built for.
export const shouldResetSubmitData = ({ currentId, heldId, modified }) => !modified || !isSameEntity(currentId, heldId)

// A receipt where nothing arrived: every row of the final payload (manual faltantes plus the
// auto-flagged shortfall) is missing. Damaged rows arrived, so they don't count. The platform closes
// such a return as UNSUCCESSFUL, sends every unit to LOST and creates no receipt, and nothing in the
// product undoes it, so the receive endpoint refuses it unless the request carries
// confirm_all_missing, which only the dedicated dialog sends (BUGS-8974).
export const isAllMissingReceipt = products => Array.isArray(products) && products.length > 0 && products.every(p => p.missing === true)

// What the all-missing dialog lists as lost: one line per product, summing the manual and the
// auto-flagged missing rows of the same product.
export const summarizeMissingProducts = products => {
  const byProduct = new Map()
  ;(products || []).forEach(p => {
    if (p.missing !== true) return
    const key = String(p.product_id)
    const current = byProduct.get(key)
    if (current) current.quantity += p.quantity || 0
    else byProduct.set(key, { product_id: p.product_id, label: p.label, upc: p.upc, sku: p.sku, quantity: p.quantity || 0 })
  })
  return [...byProduct.values()]
}
